import React from 'react';
import { usePaginateQuery } from '../../hooks/usePaginateQuery';
import { db } from '../../firebase';
import { Helmet } from 'react-helmet';
import { SimpleContainer } from '../../global.styles';

//components
import CollectionContainer from '../../components/collection-container/CollectionContainer';
import InfiniteScrollWrapper from '../../components/infinite-scroll/InfiniteScrollWrapper';
import Loader from '../../components/loader/SimpleLoader'; 

const CategoryPage = ({ match: { params } }) => {
  const { loading, hasMore, loadMore, items } = usePaginateQuery(
    db.collection('rentals').where('category', '==', params?.category),
    { limit: 6 }
  );

  const Category =
    params?.category === 'personal'
      ? 'Personal category'
      : 'Industrial category';

  if(loading) return <Loader/>; 

  return (
    <>
      <Helmet>
        <title> {Category} </title>
        <meta
          name='description'
          content={`these are SubRent rentals pertaining to ${Category}`}
        />
      </Helmet>
      <InfiniteScrollWrapper
        loading={loading}
        hasNextPage={hasMore}
        loadMore={loadMore}
      >
        {items.length ? (
          <CollectionContainer
            withRating
            columns={4}
            rentals={items}
            viewButton
            path='/rentals'
          />
        ) : (
          <SimpleContainer>
            <h4>There are no {Category} rentals at this time</h4>{' '}
          </SimpleContainer>
        )}
      </InfiniteScrollWrapper>
    </>
  );
};

export default CategoryPage;
